import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { DownloadIcon, ShieldCheckIcon, LockIcon, FileTextIcon, CheckIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 10 * 60 + 52);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prevTime => prevTime > 0 ? prevTime - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const summaryItems = ['Protocolo principal: Rescate de Parejas Post-Crisis (20 págs.)', 'BONUS #1: 7 Días para Frenar la Crisis', 'BONUS #2: Botiquín de Emergencia', 'BONUS #3: Manual Táctico de Pareja', 'BONUS #4: Re-Conexión', 'BONUS #5: Sinceridad Radical', 'Garantía total de 7 días sin preguntas', 'Descarga inmediata — acceso de por vida'];
  return <section id="oferta-final" ref={ref} className="w-full scroll-mt-14 py-24 md:py-32 bg-[#110038] relative overflow-hidden" data-id="element-128" data-mp="2171bqlz66xsg">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-129" data-mp="1r82gq67bv0nx">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-130" data-mp="1r8kg3bpadv02">
          <div className="inline-block bg-[#DC2626]/20 text-[#DC2626] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-131" data-mp="2664ge5b8n1zw">
            OFERTA ESPECIAL DE EMERGENCIA
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-serif" data-id="element-132" data-mp="2xw8zm0n9hizj">
            Tu inversión en la relación
          </h2>

          {/* Value summary ANTES del precio */}
          <div className="bg-[#0D002B] border border-[#7C3AED]/40 rounded-2xl p-6 mb-10 text-left" data-id="element-133" data-mp="10ybgkdxjugg5">
            <p className="text-[#E5A83B] font-bold text-center text-sm tracking-wider mb-4 uppercase" data-id="element-134" data-mp="m9xdc1w80pz2">
              Todo lo que recibís hoy
            </p>
            <ul className="space-y-2" data-id="element-135" data-mp="r5vylgm95rv9">
              {summaryItems.map((item, i) => <li key={i} className="flex items-start gap-3 text-[#C4B5FD] text-sm font-sans" data-id="element-136" data-mp="dak51cju27fx" data-mpi={i}>
                  <CheckIcon className="w-4 h-4 text-[#34D399] flex-shrink-0 mt-0.5" data-id="element-137" data-mp="3b30wzk8c1m2" />
                  <span data-id="element-138" data-mp="88uqvo1bddnm">{item}</span>
                </li>)}
            </ul>
            <div className="mt-4 pt-4 border-t border-[#7C3AED]/30 flex justify-between items-center" data-id="element-139" data-mp="1xokepuuu1k3w">
              <span className="text-[#A78BFA] text-sm" data-id="element-140" data-mp="22nxbp8ff47k7">
                Valor total del paquete:
              </span>
              <span className="text-white font-bold line-through opacity-50" data-id="element-141" data-mp="3n4oaay8850eb">
                $63.994 ARS
              </span>
            </div>
          </div>

          <div className="bg-[#E0D7FF] rounded-[20px] border border-white p-10 md:p-14 shadow-[0_20px_50px_-20px_rgba(124,58,237,0.3)] border-t-8 border-t-[#F5C518] relative" data-id="element-142" data-mp="pv7hidurm49">
            {/* Urgency Timer */}
            <div className="mb-10 flex flex-col items-center" data-id="element-143" data-mp="9q9tyl2jz79c">
              <div className="flex items-center gap-2 text-[#DC2626] font-bold text-lg mb-3 tracking-wide" data-id="element-144" data-mp="9oqgf28a7ab9">
                <span className="text-xl" data-id="element-145" data-mp="5r11djj91ffd">⚠️</span>
                LA OFERTA TERMINA PRONTO
              </div>
              <p className="text-[#6B5B8D] text-sm mb-5 font-sans" data-id="element-146" data-mp="jmd52gfdug8f">
                Cuando llegue a cero, el precio vuelve a{' '}
                <strong data-id="element-147" data-mp="2lfau0161goo3">$24.999</strong>
              </p>
              <div className="flex items-center gap-3 text-white font-mono text-3xl md:text-4xl font-bold" data-id="element-148" data-mp="2li6unx99trg8">
                <div className="flex flex-col items-center gap-2" data-id="element-149" data-mp="2gjc7yk86niqu">
                  <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-150" data-mp="2hxn7mm3s6kmy">
                    {Math.floor(timeLeft / 3600).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-151" data-mp="2wue7ewhd9yd3">
                    HORAS
                  </span>
                </div>
                <span className="text-[#1a1a2e] pb-6" data-id="element-152" data-mp="246ib3svpm8gu">:</span>
                <div className="flex flex-col items-center gap-2" data-id="element-153" data-mp="2471iwgrnbgh5">
                  <div className="bg-[#1a1a2e] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md" data-id="element-154" data-mp="294tk61e6key0">
                    {Math.floor(timeLeft % 3600 / 60).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#3B1F6E] text-xs font-sans font-bold tracking-wider" data-id="element-155" data-mp="1lfh3yhkfr6m7">
                    MIN
                  </span>
                </div>
                <span className="text-[#1a1a2e] pb-6" data-id="element-156" data-mp="2itg3pxqge69">:</span>
                <div className="flex flex-col items-center gap-2" data-id="element-157" data-mp="3upghad80mz7w">
                  <div className="bg-[#DC2626] rounded-lg px-4 py-3 min-w-[70px] md:min-w-[80px] flex justify-center shadow-md animate-pulse" data-id="element-158" data-mp="3ppc7t75iz4r6">
                    {(timeLeft % 60).toString().padStart(2, '0')}
                  </div>
                  <span className="text-[#DC2626] text-xs font-sans font-bold tracking-wider" data-id="element-159" data-mp="3ft8ynhc9a5uq">
                    SEG
                  </span>
                </div>
              </div>
            </div>

            {/* Price */}
            <div className="mb-6 flex flex-col items-center justify-center gap-2" data-id="element-160" data-mp="36wzy1zcjl170">
              <span className="text-2xl text-[#6B5B8D] line-through font-medium opacity-80 font-sans" data-id="element-161" data-mp="322458wzhe9su">
                $24.999
              </span>
              <div className="text-6xl md:text-7xl font-bold text-[#1E0A3C] font-serif tracking-tight" data-id="element-162" data-mp="2s1lgbnt28342">
                $11.749{' '}
                <span className="text-2xl font-normal text-[#1E0A3C]/70 font-sans tracking-normal" data-id="element-163" data-mp="2icwl86rnyfcj">
                  ARS
                </span>
              </div>
              <p className="text-[#059669] font-bold text-lg" data-id="element-164" data-mp="29eb3uexxh6dc">
                Menos que una sola sesión con el psicólogo
              </p>
            </div>

            {/* CTA Botón AMARILLO */}
            <motion.a href="https://clavedepaz.com/cart/44108367659107:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} animate={{
            boxShadow: ['0 0 0 0 rgba(245, 197, 24, 0)', '0 0 0 18px rgba(245, 197, 24, 0.3)', '0 0 0 0 rgba(245, 197, 24, 0)']
          }} transition={{
            duration: 2.5,
            repeat: Infinity,
            repeatType: 'reverse'
          }} className="w-full bg-[#F5C518] text-black px-8 py-6 rounded-xl text-xl font-extrabold shadow-[0_10px_30px_-5px_rgba(245,197,24,0.5)] hover:bg-[#e6b800] transition-colors flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3 mb-4 font-sans tracking-wide" data-id="element-165" data-mp="314h24bifoza4">
              <DownloadIcon className="w-6 h-6" data-id="element-166" data-mp="uh8k3uzju8gk" />
              <span data-id="element-167" data-mp="phvoolum3t2d">QUIERO ACCEDER AL PLAN AHORA →</span>
            </motion.a>

            <p className="text-[#6B5B8D] text-center text-sm mb-8 font-sans" data-id="element-168" data-mp="pk02bvibc6fu">
              🔒 Pago 100% seguro · Descarga inmediata · PDF en cualquier
              dispositivo
            </p>

            {/* Guarantee */}
            <div className="bg-[#F3F0FF] border border-[#C4B5FD] rounded-2xl p-6 mb-8 flex flex-col items-center text-center gap-3" data-id="element-169" data-mp="2ftjrxb54pyje">
              <ShieldCheckIcon className="w-8 h-8 text-[#7C3AED]" strokeWidth={1.5} data-id="element-170" data-mp="2au6uxxkjnb33" />
              <p className="text-[#1E0A3C] font-medium leading-relaxed font-sans" data-id="element-171" data-mp="868crxn7ejq3">
                Si no te sirve, te devolvemos tu dinero.
                <br data-id="element-172" data-mp="i67i7lobttyq" />
                <span className="text-[#6B5B8D]" data-id="element-173" data-mp="i5pey538yfhb">
                  7 días de garantía. Sin preguntas, sin vueltas.
                </span>
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 text-sm text-[#3B1F6E] pt-6 border-t border-[#C4B5FD] font-sans font-medium" data-id="element-174" data-mp="rwtvh98km8e9">
              <div className="flex items-center gap-2" data-id="element-175" data-mp="vzqhzb18eonh">
                <LockIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-176" data-mp="10ya3xbfts0fu" />
                Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-177" data-mp="15vjqmjbtxxzz">
                <DownloadIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-178" data-mp="32ov9cel2rqgc" />
                Descarga inmediata
              </div>
              <div className="flex items-center gap-2" data-id="element-179" data-mp="37ohlslt2x2o3">
                <FileTextIcon className="w-4 h-4 text-[#7C3AED]" data-id="element-180" data-mp="303x9euyyc08z" />
                PDF
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}